import { sortBy } from 'lodash';
import accounting from 'accounting';

// 判断是否为货币
function checkIsMoney(key) {
  return key.indexOf('元') !== -1;
}

export default {
  // 图例
  // 其他配置参考 https://www.echartsjs.com/zh/option.html#legend
  legend: {
    // plain 普通
    // scroll 滚动翻页，适合图例数量较多时
    type: 'plain',
    // 离容器左侧距离
    left: 'left',
    // 离容器顶部距离
    top: 25,
    // 颜色列表，按顺序循环
    // color: [],
    // 颜色标记图形的宽度
    itemWidth: 8,
    // 颜色标记图形的高度
    itemHeight: 8,
    // 图例项的 icon
    icon: 'rect',
  },

  tooltip: {
    // 坐标轴触发
    trigger: 'axis',
    formatter(params) {
      const list = sortBy(params, function(item) {
        return parseFloat(item.value);
      }).reverse();
      return list
        .map(
          (item) =>
            `${item.marker} ${item.seriesName}：${
              checkIsMoney(item.seriesName)
                ? accounting.formatMoney(item.value, '')
                : item.value //: accounting.formatNumber(item.value, '')
            }<br />`,
        )
        .join('');
    },
  },

  grid: {
    top: 90,
    bottom: 67,
    left: 120,
    right: 120,
  },

  // xAxis: {
  //   type: 'category',
  // },

  yAxis: {
    type: 'value',
  },
};

export const grid = {
  top: 90,
  bottom: 67,
  left: 120,
  right: 120,
};

export const legendStyle = {
  type: 'plain',
  left: 'left',
  top: 25,
  itemWidth: 8,
  itemHeight: 8,
  icon: 'rect',
};

export const xAxisStyle = {
  type: 'category',
};

export const tooltip = {
  trigger: 'axis',
  formatter(params) {
    const list = sortBy(params, function(item) {
      return parseFloat(item.value);
    }).reverse();
    return list
      .map((item) => {
        const isMoney = item.seriesName.indexOf('元') !== -1;
        const value = isMoney
          ? accounting.formatMoney(item.value, '￥')
          : accounting.formatNumber(item.value);
        return `${item.marker} ${item.seriesName}：${value}<br />`;
      })
      .join('');
  },
};
